import { slugify } from "@/helpers/format";

const toFormulaOne = () => ({
  name: "formula-1",
});

export const toEvents = (sport_type, query) => ({
  path: "/events",
  query: { ...query, sport_type: sport_type === "soccer" ? "football" : sport_type },
});

export const toEventsFromCity = (sport_type, query) => ({
  path: "/events",
  query: { ...query },
});

const isFormulaOne = (slug) => slug.match("formula-1-2024");

export const toTeam = ({ sport_type, slug }) =>
  toEvents(sport_type === "soccer" ? "football" : sport_type, { team: slugify(slug) });

export const toCity = ({ city }) => toEventsFromCity(city, { city: slugify(city) });

export const toTournament = ({ sport_type, slug }) =>
  isFormulaOne(slug) ? toFormulaOne() : toEvents(sport_type, { tournament: slugify(slug) });

export const toVenue = ({ sport_type, slug }) => toEvents(sport_type, { venue: slug });
